import { __spreadValues } from '../../../chunk-D6FLC3TD.mjs';
import Stack from '@mui/material/Stack';
import { jsx } from 'react/jsx-runtime';

var FullPageContainer = (props) => {
  const { sx, children } = props;
  return /* @__PURE__ */ jsx(Stack, { useFlexGap: true, spacing: 0, sx: __spreadValues({ minHeight: "100vh", maxHeight: "100vh", overflow: "hidden" }, sx), children });
};

export { FullPageContainer };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=index.mjs.map